<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col group-title d-flex">
            <div class="col alert alert-primary">
              <span class="my-auto" v-if="needPresenterData() || (author && author.role_id === 2)"><icon
                  :icon="['fad', 'user']"/>&nbsp;{{ _[abstract.setting_submission_id].author.title_presenter }}</span>
              <span class="my-auto" v-else><icon
                  :icon="['fad', 'user']"/>&nbsp;{{ _[abstract.setting_submission_id].author.title_author }}</span>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col">
            <speaker v-if="needPresenterData() || (author && author.role_id === 2)"
                     :submission_id="abstract.setting_submission_id" area="author"
                     textkey="info_top_presenter"></speaker>
            <speaker v-else :submission_id="abstract.setting_submission_id" area="author"
                     textkey="info_top_coauthor"></speaker>
          </div>
        </div>
        <div class="row mt-3" v-if="!editAuthor">
          <div class="col">
            <button class="btn btn-primary" v-on:click="cloneContact()">
              <icon :icon="['fad', 'copy']"/>&nbsp;{{ _[abstract.setting_submission_id].author.button_copy }}
            </button>
          </div>
        </div>
        <entitegenerator v-if="author"
                         :entities="entities"
                         :values="author"
                         :system="{main: 'submission', action: 'create'}"
                         :models="{'gender':gender,'salutation':salutation, 'international_organisation':datahelper.international_organisation, 'countries':countryData()}"
                         :error="globalerror"
                         :language="language"
                         mode="formular"></entitegenerator>
        <Loader v-else></Loader>
      </div>
    </div>
    <div class="row mt-3" v-if="mode.confirm === true">
      <div class="col d-flex">
        <router-link :to="'/abstract/' + this.$route.params.id + '/confirm'" class="pull-left" @click="processing.preschange = false">
          <button type="button" class="btn btn-info">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            {{ _[abstract.setting_submission_id].author.button_back_no_save }}
          </button>
        </router-link>
        <button v-if="!editAuthor && !processing.author" type="button" class="btn btn-success ml-auto"
                v-on:click="createAuthor()">
          <icon :icon="['fal', 'save']" size="lg"/>
          {{ _[abstract.setting_submission_id].author.button_add_institute_with_save }}
        </button>
        <button v-if="(editAuthor && editorMode === 'formular') && !processing.author" type="button"
                class="btn btn-success ml-auto"
                v-on:click="putAuthor()">
          <icon :icon="['fal', 'save']" size="lg"/>
          {{ _[abstract.setting_submission_id].author.button_back_with_save }}
        </button>
        <button class="btn btn-success ml-auto" type="button" disabled v-if="processing.author">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ wording[0].buttons.processing }}
        </button>
      </div>
    </div>
    <div class="row mt-3" v-else>
      <div class="col d-flex">
        <router-link :to="'/abstract/' + this.$route.params.id + '/authors'" class="pull-left" @click="processing.preschange = false">
          <button type="button" class="btn btn-info">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            {{ _[abstract.setting_submission_id].author.button_back_no_save }}
          </button>
        </router-link>
        <button v-if="!editAuthor && !processing.author" type="button" class="btn btn-success ml-auto"
                v-on:click="createAuthor()">
          <icon :icon="['fal', 'save']" size="lg"/>
          {{ _[abstract.setting_submission_id].author.button_add_institute_with_save }}
        </button>
        <button v-if="(editAuthor && editorMode === 'formular') && !processing.author" type="button"
                class="btn btn-success ml-auto"
                v-on:click="putAuthor()">
          <icon :icon="['fal', 'save']" size="lg"/>
          {{ _[abstract.setting_submission_id].author.button_back_with_save }}
        </button>
        <button class="btn btn-success ml-auto" type="button" disabled v-if="processing.author">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ wording[0].buttons.processing }}
        </button>
      </div>
    </div>
    <div class="modal fade" id="ruleXCheckErrorModal" tabindex="-1" role="dialog"
         aria-labelledby="ruleXCheckErrorModal" aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="ruleXCheckErrorModalTitle">
              Presenter check </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'exclamation']" class="my-auto mx-auto text-warning fa-2x"/>
              </div>
              <div class="col">
                Save was <strong>not</strong> successful.<br>This presenter has too many confirmed presentations (max
                {{ settings.confirmation.xcheck.countGreaterThen }} confirmed presentations allowed).<br><br>
                <strong>We had to reset the presenter, you have to select another presenter for this abstract.</strong>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button v-on:click="disableAsPresenter()" class="btn btn-primary" data-dismiss="modal">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import entitegenerator from 'entite-generator';

export default {
  name: "AuthorForm",
  components: {entitegenerator},
  data() {
    return {
      institute: {},
      editorMode: 'formular',
      editAuthor: false,
      error: null,
    };
  },
  computed: {
    ...mapState([
      'abstract',
      'author',
      'authors',
      'institutes',
      'wording',
      'countries',
      'settings',
      'salutation',
      'processing',
      'user',
      'authorvalidation',
      'datahelper',
      'gender',
      'mode',
      "language"
    ]),
    ...mapGetters([
      'getCurrentPageByType', 'getPresenter'
    ]),
    entities: function () {
      if (this.needPresenterData() || (this.author && this.author.role_id === 2)) {
        return this.getCurrentPageByType(this.abstract.setting_submission_id, 2).entity.presenter.author
      }
      return this.getCurrentPageByType(this.abstract.setting_submission_id, 2).entity.coauthor.author
    },
    globalerror: function () {
      if (this.error) {
        return this.error;
      }
      if ((this.author.id && this.author.id > 0) && (this.authorvalidation.is_checked === true && this.authorvalidation.status === false)) {
        let validation = this.authorvalidation.errors.find(valid => valid.author_id === this.author.id);
        if (validation && validation.error) return validation.error;
      }
      return {}
    },
    presenterChangeMode: function () {
      return this.$route.name === 'presenterchange';
    },
  },
  created() {
    if (this.$route.params.authorid) {
      this.editAuthor = true;
    } else {
      this.$store.commit('SET_AUTHOR', {"author": {}});
    }
  },
  methods: {
    ...mapActions([
      'VALIDATE_TARGET', 'CREATE_AUTHOR', 'PUT_AUTHOR', 'VALIDATE_INTEGRITY_AUTHOR', 'GET_AUTHORS_RESPONSE'
    ]),
    needPresenterData() {
      if (this.presenterChangeMode === true) {
        return true;
      }
      let authors = this.$store.state.authors;
      let present = true;
      authors.forEach(function (element) {
        if (element.role_id === 2) {
          present = false;
        }
      });
      return present;
    },
    disableAsPresenter() {
      this.author.role_id = 1;
      this.putAuthor();
    },
    //TODO: Umstrukturieren wie PUT.
    createAuthor() {
      if (this.author.firstname && this.author.lastname){
        if (this.authors.find(author => author.firstname.toLowerCase() === this.author.firstname.toLowerCase() && author.lastname.toLowerCase() === this.author.lastname.toLowerCase())) {
          this.$noty.error(this.wording[this.abstract.setting_submission_id].notify.author_exist);
          this.processing.author = false;
          return false;
        }
      }
      this.processing.author = true;
      let needpresenter = this.needPresenterData();
      let target = this.abstract.setting_submission_id + '/';
      target += needpresenter ? 'presenter/author' : 'coauthor/author';
      let data = {template: {}, target: target};
      data.template = this.author;
      data.template.abstract_id = this.$route.params.id;
      data.template.order = this.$store.state.authors.length + 1;
      data.template.role_id = needpresenter ? 2 : 1;
      this.VALIDATE_TARGET(data).then((validationresult) => {
        this.editorMode = 'preview';
        this.CREATE_AUTHOR(data).then((responseAuthor) => {
          this.processing.author = false;
          this.$noty.success(this.wording[0].notify.save_success);
          this.error = {};
          this.$router.push(responseAuthor.data.id + '/institute/add');
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.save_not_success);
          this.processing.author = false;
        })
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.validation_error);
        this.processing.author = false;
        this.error = error.response.data;
      })
    },

    // true wenn der Test ausgeschlagen hat, bei false ist alles ok.
    async ruleOfXCheck() {
      let ruleX = false;
      if (this.mode.confirm === true && (this.settings.confirmation.xcheck && this.settings.confirmation.xcheck.presenter === true) && this.author.role_id === 2) {
        let template = {
          "firstname": this.author.firstname,
          "lastname": this.author.lastname,
          "email": this.author.email,
          "setting_submission_id": [this.abstract.setting_submission_id],
          "additionalWhere": [{'field': 'confirmed', 'operator': '=', 'search': true}]
        };
        await this.VALIDATE_TARGET({
          template: template,
          target: 'xcheck/presenter'
        }).then((result) => {
          ruleX = result.data >= this.settings.confirmation.xcheck.countGreaterThen;
        }).catch((error) => {
          ruleX = false;
        });
      }
      return ruleX;
    },
    async validateAuthor(target) {
      let validation = false;
      await this.VALIDATE_TARGET({
        template: this.author,
        target: target
      }).then((result) => {
        this.error = {};
        validation = true;
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.validation_error);
        this.error = error.response.data;
        validation = false;
      })
      return validation;
    },
    async putAuthor() {
      this.processing.author = true;
      if (this.presenterChangeMode === true) {
        this.author.role_id = 2;
      }
      //Autor validieren
      let target = this.abstract.setting_submission_id + '/';
      target += this.author.role_id === 2 ? 'presenter/author' : 'coauthor/author';
      let validation = await this.validateAuthor(target);
      if (validation === false) {
        this.processing.author = false;
        return false;
      }
      // Eventuell nen RuleOfX Check durchführen
      let ruleXCheck = await this.ruleOfXCheck();
      if (ruleXCheck) {
        // this.$noty.error("Save was <strong>not</strong> successful.<br>This presenter has too many confirmed presentations (max " + this.settings.confirmation.xcheck.countGreaterThen + " confirmed presentations allowed).");
        $('#ruleXCheckErrorModal').modal('show');
        this.processing.author = false;
        return false;
      }
      // Autor speichern
      await this.PUT_AUTHOR({
        id: this.author.id,
        abstract_id: this.author.abstract_id,
        template: this.author
      }).then(async (result) => {
        this.error = {};
        if (this.presenterChangeMode === true) {
          await this.changePresenter();
          await this.GET_AUTHORS_RESPONSE(this.abstract.id).then((response) => {
            this.$store.commit('SET_AUTHORS', {authors: response.data});
          }).catch((error) => {
          })
        }
        this.$noty.success(this.wording[0].notify.save_success);
        this.processing.author = false;
        this.processing.preschange = false;
        if (this.mode.confirm === true) {
          this.$router.push('/abstract/' + this.$route.params.id + '/confirm');
        } else {
          this.$router.push('/abstract/' + this.$route.params.id + '/authors');
        }
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
        this.processing.author = false;
        this.error = error.response.data;
      })
    },
    cloneContact() {
      this.copyContactfield('firstname', 'firstName');
      this.copyContactfield('lastname', 'lastName');
      if (this.needPresenterData()) {
        this.copyContactfield('email', 'emailBusiness');
      }
    },
    copyContactfield(to, from) {
      if (this.user[from]) {
        this.$set(this.author, to, this.user[from])
      }
    },
    async changePresenter() {
      if (this.settings.authors.max_presenter === 1) {
        // Wenn er nur einen hat, switchen wir.
        let presenter = this.getPresenter;
        presenter[0].role_id = 1;
        this.PUT_AUTHOR({template: {role_id: 1}, id: presenter[0].id}).then((result) => {
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.save_not_success);
          this.processing.author = false;
        })
        if (this.settings.authors.presenter_first && this.settings.authors.presenter_first === true) {
          let data = this.authors.filter(item => item.role_id !== 2);
          data.unshift(this.author);
          this.authors = data;
        }
      } else {
        //Hat er mehr als einen, muss er ran.
        // $('#maxPresenterModal').modal('show');
      }
    }
  }
}
</script>
